import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "convert row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Converter", -1)
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("nav", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "nav nav-tabs",
    id: "nav-tab",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-item nav-link active",
      id: "nav-editor-tab",
      "data-toggle": "tab",
      href: "#nav-editor",
      role: "tab",
      "aria-controls": "nav-editor",
      "aria-selected": "true"
    }, "Editor"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-item nav-link",
      id: "nav-results-tab",
      "data-toggle": "tab",
      href: "#nav-results",
      role: "tab",
      "aria-controls": "nav-results",
      "aria-selected": "false"
    }, "Results"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-item nav-link",
      id: "nav-slipi-tab",
      "data-toggle": "tab",
      href: "#nav-slipi",
      role: "tab",
      "aria-controls": "nav-slipi",
      "aria-selected": "false"
    }, "Slipi")
  ])
], -1)
const _hoisted_5 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_6 = {
  class: "tab-pane fade show active",
  id: "nav-editor",
  role: "tabpanel",
  "aria-labelledby": "nav-editor-tab"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 mt-2" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "-- SCHEMA --", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "-- SRC LANG --", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = {
  class: "tab-pane fade",
  id: "nav-results",
  role: "tabpanel",
  "aria-labelledby": "nav-results-tab"
}
const _hoisted_20 = { class: "p-2" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  class: "tab-pane fade",
  id: "nav-slipi",
  role: "tabpanel",
  "aria-labelledby": "nav-slipi-tab"
}
const _hoisted_25 = { class: "p-2" }
const _hoisted_26 = {
  key: 0,
  class: "d-flex align-content-start flex-wrap"
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_30 = {
  key: 1,
  class: "d-flex align-content-start flex-wrap"
}
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    id: "schema",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schema) = $event))
                  }, [
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roman_schemas, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.id,
                        value: s.id
                      }, _toDisplayString(s.name), 9, _hoisted_12))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.schema]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    id: "language",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.language) = $event)),
                    required: "true"
                  }, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (l) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: l.id,
                        value: l.id
                      }, _toDisplayString(l.name), 9, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.language]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn btn-primary mr-2",
                    type: "submit",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.convert()), ["prevent"])),
                    disabled: !_ctx.schema || !_ctx.language || !_ctx.src
                  }, " Convert ", 8, _hoisted_17)
                ])
              ])
            ])
          ]),
          _hoisted_18,
          _createVNode(_component_editor, {
            modelValue: _ctx.src,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.src) = $event)),
            "api-key": "8kpycxhjheir0b2odz6yw1kfsyxo9pm6qtaa0u5temvzej6u",
            id: "src",
            inline: true,
            init: {
                menubar: false,
                plugins: 'lists link image emoticons paste code',
                toolbar: 'styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image emoticons | removeformat | code',
                paste_as_text: true
            },
            placeholder: "Copy and paste some text in here"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (value, propertyName) => {
              return (_openBlock(), _createElementBlock("div", {
                title: propertyName,
                key: propertyName
              }, [
                value
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createElementVNode("small", null, _toDisplayString(propertyName), 1),
                      _createElementVNode("div", { innerHTML: value }, null, 8, _hoisted_23)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_21))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (_ctx.results && _ctx.results.latin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wordMapper(_ctx.src, _ctx.results.latin), (wordMapping, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "pr-2 pb-2",
                      key: index
                    }, [
                      _createElementVNode("div", {
                        innerHTML: wordMapping.src
                      }, null, 8, _hoisted_27),
                      _createElementVNode("div", {
                        innerHTML: wordMapping.lipi
                      }, null, 8, _hoisted_28)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_29,
            (_ctx.results && _ctx.results.latin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wordMapper(_ctx.src, _ctx.results.latin), (wordMapping, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "pr-2 pb-2",
                      key: index
                    }, [
                      _createElementVNode("div", {
                        innerHTML: wordMapping.src+' '+wordMapping.lipi
                      }, null, 8, _hoisted_31)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}